"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterShowOnlyGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
exports.defaultSfilterShowOnlyGroupState = {
    name: 'Show Only',
    key: SfilterKey_1.SfilterKey.SHOWONLY,
    opened: false,
    options: [
        { name: 'Virtual Tour', selected: false, key: 'vr' },
        { name: 'Video', selected: false, key: 'video' },
    ],
};
